import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';
import { useEffect } from 'react';
import { TextLabel, Textfield } from 'components/common';

import Grid from '@material-ui/core/Grid';

import { onlyNumber } from 'utils/formatter';

const SecondResetForm = ({ state, onChange, handleChange }) => {
  const { formatMessage } = useIntl();
  const { accountNumber, otpNumber } = state;

  useEffect(() => {
    onChange({ ...state, accountNumber: '', otpNumber: '' });
  }, []);

  return (
    <Grid container spacing={1} alignItems="center" className="form-spacing">
      <Grid item xs={12} sm={5}>
        <TextLabel label={formatMessage({ id: 'resetCredential.modal.container.accountNumber' })} />
      </Grid>
      <Grid item xs={12} sm={7}>
        <Textfield
          id="account-number-reset"
          value={accountNumber}
          placeholder={formatMessage({ id: 'resetCredential.modal.placeholder.numberPlaceholder' })}
          onChange={e => handleChange('accountNumber', onlyNumber(e.target.value))}
          type="text"
        />
      </Grid>
      <Grid item xs={12} sm={5} className="text-otp">
        <TextLabel label={formatMessage({ id: 'resetCredential.modal.container.otpNumber' })} />
      </Grid>
      <Grid item xs={12} sm={7}>
        <Textfield
          id="otp-number-reset"
          value={otpNumber}
          type="text"
          onChange={e => handleChange('otpNumber', onlyNumber(e.target.value))}
          placeholder={formatMessage({ id: 'resetCredential.modal.placeholder.otpPlaceholder' })}
          hasTextLine
          textLineMessage={formatMessage({ id: 'resetCredential.modal.container.messageOtp' })}
          maxLength={8}
        />
      </Grid>
    </Grid>
  );
};

SecondResetForm.defaultProps = {
  state: {},
};

SecondResetForm.propTypes = {
  state: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default SecondResetForm;
